import { connect } from 'react-redux'
import { getErrors } from '../../../redux/selectors/toasterSelector'
import { ToasterComponent } from './ToasterComponent'
import { IToasterComponentProps } from './types/IToasterComponentProps'

const mapStateToProps = (state: any): any => {
	return {
		// data: getErrors(state),
	}
}

export const ToasterContainer = connect(mapStateToProps, {})(ToasterComponent)
